/**
 * 字体图标, 统一使用SVG Sprite矢量图标(http://www.iconfont.cn/
 */
import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// 写了组件在打开 用于注册组件

Vue.component('svg-icon', SvgIcon)// 写了组件在打开 用于注册组件

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /.svg$/)
requireAll(req)
